import { Icon } from "@blueprintjs/core";
import { Popover2 } from "@blueprintjs/popover2";

interface Props {
  content: JSX.Element;
  verticalOffset?: string;
}

export const Popover: React.FC<Props> = ({ content, verticalOffset }) => {
  return (
    // Negative marginTop is used to "align" Icon next to simple text.
    <div style={{ margin: `${verticalOffset ?? "0"} 4px 4px 4px`, display: "inline-block" }}>
      <Popover2 content={content} popoverClassName="w-80 z-10 bg-custom-blue">
        <Icon icon="info-sign" color={"#215383"} />
      </Popover2>
    </div>
  );
};
